import TranslatesContent from "../../DataStore/Languages/translatesContent";

const MobileField = ({country , updatePhone , phoneNumber}) => {
    return ( 
        <div className="form-group">
        <label htmlFor="exampleInputPassword1"><TranslatesContent contentKey="mobile-number"/></label>
        <div className="input-group mb-3">
            <span className="input-group-text" 
            // style={{                      
            //     border: "1px solid #6E9EF7",
            //     fontWeight: 600,
            //     backgroundColor: "#6E9EF7",
            //     color: "#fff",}}
                id="basic-addon1">+{country.split('-')[1]}
            </span>
            <input
                onChange={(e)=>updatePhone(e)}
                value={phoneNumber}
                type="text"
                className="form-control mobile-field-input"
                placeholder="XXX XXX XXX"
                aria-label="XXX XXX XXX"
                aria-describedby="basic-addon1"
            />
        </div>

        <style>{`
            .mobile-field-input::placeholder { color: #fff; opacity: 1; }
            .mobile-field-input::-webkit-input-placeholder { color: #fff; }
            .mobile-field-input::-moz-placeholder { color: #fff; opacity: 1; }
            .mobile-field-input:-ms-input-placeholder { color: #fff; }
            .mobile-field-input::-ms-input-placeholder { color: #fff; }
        `}</style>
        </div>
     );
}
 
export default MobileField;